var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u72B6\\u6001\\u89C4\\u8303",
    transform: "translate(-862.000000, -1850.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(614.000000, 1796.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(248.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5783\\u573E\\u6876",
    transform: "translate(1.375000, 0.803711)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4375,2.25 L8.4375,0.5625 L8.4375,0 L2.8125,0 L2.8125,0.5625 L2.8125,2.25 L0,2.25 L0,2.8125 L0,3.375 L1.125,3.375 L1.125,10.7050781 L1.125,12.3925781 L10.125,12.3925781 L10.125,10.7050781 L10.125,3.375 L11.25,3.375 L11.25,2.8125 L11.25,2.25 L8.4375,2.25 Z M3.9375,1.125 L7.3125,1.125 L7.3125,2.23242187 L3.9375,2.23242187 L3.9375,1.125 Z M9,10.7050781 L9,11.2675781 L2.25,11.2675781 L2.25,10.7050781 L2.25,3.375 L9,3.375 L9,10.7050781 Z M3.9375,10.125 L3.9375,5.0625 L4.5,5.0625 L5.0625,5.0625 L5.0625,10.125 L4.5,10.125 L3.9375,10.125 Z M6.1875,10.125 L6.1875,5.0625 L6.75,5.0625 L7.3125,5.0625 L7.3125,10.125 L6.75,10.125 L6.1875,10.125 Z",
    id: "\\u5F62\\u72B6"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDelete);
export default __webpack_public_path__ + "static/media/upload_delete.08ad90e0.svg";
export { ForwardRef as ReactComponent };